export const CEP_URL_BY_BRAND = {
  br: 'http://www.buscacep.correios.com.br/sistemas/buscacep/',
  mx: 'https://micodigopostal.org/',
  co: 'http://visor.codigopostal.gov.co/472/visor/',
  cl: 'https://www.correos.cl/SitePages/home.aspx',
  ar: 'https://www.correoargentino.com.ar/formularios/cpa',
  pe: 'https://www.gob.pe/521-consulta-tu-codigo-postal-nacional',
  bo: 'https://correos.gob.bo/',
  cr: 'https://correos.go.cr/codigo-postal/',
  do: 'https://inposdom.gob.do/codigo-postal/',
  ec: 'https://www.codigopostal.gob.ec/',
  sv: 'https://www.listasal.info/articulos/codigo-postal-el-salvador.shtml',
  pa: 'https://www.officedepot.com.pa/officedepotPA/en/CodigosPostales',
  py: 'https://codigo-postal.org/paraguay/',
  uy: 'https://www.correo.com.uy/codigospostales',
};
